import { Spin, Tooltip } from 'antd'

const AdminErShopCheckListTable = ({
  items,
  editMode,
  editField,
  handleQtyChange,
  saveQty,
  handleQtyKeyPress,
  toggleEdit,
  openLogModal,
  lastElementRef,
  handleRemarkChange,
  handleRemarkKeyPress,
  saveRemark,
  isLoading,
  currentPage,
}) => {
  function formatDate(dateString) {
    const date = new Date(dateString)
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const seconds = date.getSeconds().toString().padStart(2, '0')
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  }

  const truncateWords = (text, limit = 8) => {
    if (!text) return ''
    const words = text.split(' ')
    return words.length > limit ? words.slice(0, limit).join(' ') + '...' : text
  }

  return (
    <table className='table actable'>
      <thead>
        <tr>
          <th>Item Code</th>
          <th>Desc</th>
          <th>Item Grp</th>
          <th>Item Type</th>
          <th className='text-center'>Qty</th>
          <th className='text-center text-nowrap' title='Physical Qty'>
            Phy Qty
          </th>
          <th>Remark</th>
          <th>Last Updated</th>
        </tr>
      </thead>
      <tbody>
        {isLoading && currentPage === 1 ? (
          <tr>
            <td colSpan='8' className='text-center'>
              <Spin size='small' />
            </td>
          </tr>
        ) : items.length > 0 ? (
          items.map((item, index) => (
            <tr
              key={item._id}
              ref={index === items.length - 1 ? lastElementRef : null}
            >
              <td>{item.itemCode}</td>
              <td>
                <Tooltip title={item.description} placement='topLeft'>
                  <span style={{ cursor: 'help' }}>
                    {truncateWords(item.description)}
                  </span>
                </Tooltip>
              </td>
              <td>{item.itemGrp}</td>
              <td>{item.itemType}</td>
              <td className='text-center'>{item.erShopQty}</td>
              <td className='text-center'>
                {editMode === item._id && editField === 'checkQty' ? (
                  <input
                    type='number'
                    className='form-control'
                    style={{ width: '100px', margin: 'auto' }}
                    value={item.checkQty}
                    onChange={(e) =>
                      handleQtyChange(item._id, e.target.value, 'checkQty')
                    }
                    onBlur={() => saveQty(item._id, 'checkQty')}
                    onKeyDown={(e) =>
                      handleQtyKeyPress(e, item._id, 'checkQty')
                    }
                    onFocus={(e) => e.target.select()}
                    min='0'
                    autoFocus
                  />
                ) : (
                  <span
                    onClick={() =>
                      toggleEdit(item._id, 'checkQty', item.checkQty)
                    }
                    style={{
                      cursor: 'pointer',
                      paddingLeft: '15px',
                      paddingRight: '15px',
                    }}
                  >
                    {item.checkQty}
                  </span>
                )}
              </td>
              <td>
                {editMode === item._id && editField === 'remark' ? (
                  <input
                    type='text'
                    className='form-control'
                    value={item.remark}
                    onChange={(e) =>
                      handleRemarkChange(item._id, e.target.value)
                    }
                    onBlur={() => saveRemark(item._id)}
                    onKeyDown={(event) => handleRemarkKeyPress(event, item._id)}
                    autoFocus
                  />
                ) : (
                  <span
                    onClick={() => toggleEdit(item._id, 'remark', item.remark)}
                    style={{ cursor: 'pointer' }}
                  >
                    {item.remark ? (
                      item.remark
                    ) : (
                      <i
                        className='bi bi-pencil-fill'
                        style={{
                          cursor: 'pointer',
                          color: 'grey',
                          fontSize: '12px',
                        }}
                      ></i>
                    )}
                  </span>
                )}
              </td>
              <td>
                {item.lastUptByCode && (
                  <>
                    <span style={{ cursor: 'pointer', marginRight: '10px' }}>
                      <i
                        className='bi-info-circle-fill'
                        style={{ color: '#00a6ff' }}
                        onClick={() => openLogModal(item._id)}
                      ></i>
                    </span>
                    {item.lastUptByCode}{' '}
                    {item.lastUptDate ? formatDate(item.lastUptDate) : ''}
                  </>
                )}
              </td>
            </tr>
          ))
        ) : (
          // Show "No items found" if there are no items to display
          <tr>
            <td colSpan='8'>No items found</td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export default AdminErShopCheckListTable
